import { PageState } from '@/features/Transition360/ui/PageState';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/',
)({
    component: StatusReportsIndexRoute,
});

function StatusReportsIndexRoute() {
    return (
        <div
            data-testid="StatusReportsIndex"
            className="rounded-lg border border-slate-200 bg-white"
        >
            <PageState
                title="Choose a report"
                description="Pick a report from the list to see its rows."
            />
        </div>
    );
}
